// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__rubik_888d6c', '__rubik_Fallback_888d6c'"},"className":"__className_888d6c","variable":"__variable_888d6c"};